module.exports = __webpack_public_path__ + "static/img/4_v2.1b0840e7.png";